import { useDispatch } from 'react-redux';
import type { AppDispatch } from './types';

export type { AppDispatch };

export const useAppDispatch = () => useDispatch<AppDispatch>();
